// @ts-nocheck
import { AbstractCompositeQuestionInfo } from "./AbstractCompositeQuestionInfo";

export class CompositeQuestionInfo extends AbstractCompositeQuestionInfo {
  constructor() {
    super();
  }

  getVisits(): number {
    // Manual Code Here
  }
}
